import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange, articleCounts }) => {

  return (
    <div className="bg-card rounded-lg literary-shadow p-6">
      <h3 className="font-headline text-lg font-semibold text-primary mb-4">
        Categorías
      </h3>
      <div className="space-y-2">
        <button
          onClick={() => onCategoryChange('all')}
          className={`w-full flex items-center justify-between px-4 py-3 rounded-lg literary-transition text-left ${
            activeCategory === 'all' ?'bg-primary text-primary-foreground' :'text-foreground hover:bg-primary/5 hover:text-primary'
          }`}
        >
          <div className="flex items-center space-x-3">
            <Icon name="Grid" size={18} />
            <span className="font-medium">Todos los artículos</span>
          </div>
          <span className={`text-sm px-2 py-1 rounded ${
            activeCategory === 'all' ?'bg-primary-foreground/20 text-primary-foreground' :'bg-muted text-muted-foreground'
          }`}>
            {Object.values(articleCounts)?.reduce((sum, count) => sum + count, 0)}
          </span>
        </button>
        
        {categories?.map((category) => (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            className={`w-full flex items-center justify-between px-4 py-3 rounded-lg literary-transition text-left ${
              activeCategory === category
                ? 'bg-primary text-primary-foreground'
                : 'text-foreground hover:bg-primary/5 hover:text-primary'
            }`}
          >
            <div className="flex items-center space-x-3">
              <span className="font-medium">{category}</span>
            </div>
            <span className={`text-sm px-2 py-1 rounded ${
              activeCategory === category
                ? 'bg-primary-foreground/20 text-primary-foreground'
                : 'bg-muted text-muted-foreground'
            }`}>
              {articleCounts?.[category] || 0}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;